import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      !_vm.isModal
        ? [
            _c("div", { staticClass: "display-1" }, [_vm._v("Lee y Aprende")]),
            _c(VBreadcrumbs, {
              staticClass: "pa-0 py-2",
              attrs: { items: _vm.breadcrumbs },
            }),
            _c(
              VCard,
              { staticClass: "mt-2 pb-3 pr-3" },
              [
                _c(
                  VTabs,
                  {
                    attrs: { vertical: "" },
                    model: {
                      value: _vm.tab,
                      callback: function ($$v) {
                        _vm.tab = $$v
                      },
                      expression: "tab",
                    },
                  },
                  [
                    _c(
                      VTab,
                      {
                        on: {
                          click: function ($event) {
                            return _vm.sendtoGA(0)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("menu.data_platform")))]
                    ),
                    _c(
                      VTab,
                      {
                        on: {
                          click: function ($event) {
                            return _vm.sendtoGA(1)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("menu.audience")))]
                    ),
                    _c(
                      VTab,
                      {
                        on: {
                          click: function ($event) {
                            return _vm.sendtoGA(2)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("menu.attributes")) + " ")]
                    ),
                    _c(
                      VTab,
                      {
                        on: {
                          click: function ($event) {
                            return _vm.sendtoGA(3)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("menu.customer_insights")) + " ")]
                    ),
                    _vm._l(_vm.preguntas, function (item, a) {
                      return _c(
                        VTabItem,
                        [
                          _c(VContainer, { staticClass: "pb-0" }, [
                            _c("table", { attrs: { width: "100%" } }, [
                              _c("col", { staticStyle: { width: "1%" } }),
                              _c("col", { staticStyle: { width: "30%" } }),
                              _c("thead", [
                                _c("tr", [
                                  _c(
                                    "th",
                                    [
                                      _c(
                                        VBtn,
                                        {
                                          staticStyle: {
                                            "background-color": "#0048CF",
                                          },
                                          attrs: { icon: "", color: "white" },
                                        },
                                        [_c(VIcon, [_vm._v("mdi-pencil")])],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("th", [
                                    _c(
                                      "h5",
                                      { staticClass: "font-weight-bold" },
                                      [_vm._v("Descripción")]
                                    ),
                                  ]),
                                ]),
                              ]),
                              _c("tbody", [
                                _c("tr", [
                                  _c("td"),
                                  _c(
                                    "td",
                                    { staticStyle: { color: "#000000DE" } },
                                    [_vm._v(_vm._s(item.description))]
                                  ),
                                ]),
                              ]),
                            ]),
                          ]),
                          _c(VContainer, { staticClass: "pb-0" }, [
                            _c("table", { attrs: { width: "100%" } }, [
                              _c("col", { staticStyle: { width: "1%" } }),
                              _c("col", { staticStyle: { width: "30%" } }),
                              _c("thead", [
                                _c("tr", [
                                  _c(
                                    "th",
                                    [
                                      _c(
                                        VBtn,
                                        {
                                          staticStyle: {
                                            "background-color": "#0048CF",
                                          },
                                          attrs: { icon: "", color: "white" },
                                        },
                                        [_c(VIcon, [_vm._v("mdi-star")])],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("th", [
                                    _c(
                                      "h5",
                                      { staticClass: "font-weight-bold" },
                                      [_vm._v("Funcionalidades principales")]
                                    ),
                                  ]),
                                ]),
                              ]),
                              _c("tbody", [
                                _c("tr", [
                                  _c("td"),
                                  _c(
                                    "td",
                                    { staticStyle: { color: "#000000DE" } },
                                    _vm._l(
                                      item.functionalities,
                                      function (func) {
                                        return _c("li", [_vm._v(_vm._s(func))])
                                      }
                                    ),
                                    0
                                  ),
                                ]),
                              ]),
                            ]),
                          ]),
                          _c(VContainer, { staticClass: "pb-0" }, [
                            _c("table", { attrs: { width: "100%" } }, [
                              _c("col", { staticStyle: { width: "1%" } }),
                              _c("col", { staticStyle: { width: "30%" } }),
                              _c("thead", [
                                _c("tr", [
                                  _c(
                                    "th",
                                    [
                                      _c(
                                        VBtn,
                                        {
                                          staticStyle: {
                                            "background-color": "#0048CF",
                                          },
                                          attrs: { icon: "", color: "white" },
                                        },
                                        [_c(VIcon, [_vm._v("icon-search")])],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("th", [
                                    _c(
                                      "h5",
                                      { staticClass: "font-weight-bold" },
                                      [_vm._v("Glosario de términos")]
                                    ),
                                  ]),
                                ]),
                              ]),
                              _c("tbody", [
                                _c("tr", [
                                  _c("td"),
                                  _c(
                                    "td",
                                    { staticStyle: { color: "#000000DE" } },
                                    [
                                      _vm.preguntas[a].gterms &&
                                      _vm.preguntas[a].gterms.length > 0
                                        ? _c(
                                            VCarousel,
                                            {
                                              staticClass: "myCarousel",
                                              staticStyle: { width: "97%" },
                                              attrs: {
                                                height: "auto",
                                                "hide-delimiters": "",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "prev",
                                                    fn: function (ref) {
                                                      var on = ref.on
                                                      var attrs = ref.attrs
                                                      return [
                                                        _c(
                                                          VIcon,
                                                          _vm._g(
                                                            _vm._b(
                                                              {},
                                                              "v-icon",
                                                              attrs,
                                                              false
                                                            ),
                                                            on
                                                          ),
                                                          [
                                                            _vm._v(
                                                              "mdi-chevron-left"
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "next",
                                                    fn: function (ref) {
                                                      var on = ref.on
                                                      var attrs = ref.attrs
                                                      return [
                                                        _c(
                                                          VIcon,
                                                          _vm._g(
                                                            _vm._b(
                                                              {},
                                                              "v-icon",
                                                              attrs,
                                                              false
                                                            ),
                                                            on
                                                          ),
                                                          [
                                                            _vm._v(
                                                              "mdi-chevron-right"
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                              model: {
                                                value: _vm.model[a],
                                                callback: function ($$v) {
                                                  _vm.$set(_vm.model, a, $$v)
                                                },
                                                expression: "model[a]",
                                              },
                                            },
                                            _vm._l(
                                              _vm.preguntas[a].gterms,
                                              function (term, i) {
                                                return _c(
                                                  VCarouselItem,
                                                  { key: i },
                                                  [
                                                    _c(
                                                      VCard,
                                                      {
                                                        staticClass: "mx-8",
                                                        attrs: { outlined: "" },
                                                      },
                                                      [
                                                        _c(VCardTitle, [
                                                          _vm._v(
                                                            _vm._s(term.title)
                                                          ),
                                                        ]),
                                                        _c(VCardText, [
                                                          _vm._v(
                                                            _vm._s(
                                                              term.description
                                                            )
                                                          ),
                                                        ]),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            1
                                          )
                                        : _c("div", [
                                            _vm._v(
                                              "Estamos trabajando en nuestro glosario de términos"
                                            ),
                                          ]),
                                    ],
                                    1
                                  ),
                                ]),
                              ]),
                            ]),
                          ]),
                          _c(VContainer, { staticClass: "pb-0" }, [
                            _c("table", { attrs: { width: "100%" } }, [
                              _c("col", { staticStyle: { width: "1%" } }),
                              _c("col", { staticStyle: { width: "30%" } }),
                              _c("thead", [
                                _c("tr", [
                                  _c(
                                    "th",
                                    [
                                      _c(
                                        VBtn,
                                        {
                                          staticStyle: {
                                            "background-color": "#0048CF",
                                          },
                                          attrs: { icon: "", color: "white" },
                                        },
                                        [
                                          _c(VIcon, [
                                            _vm._v("mdi-file-document-outline"),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("th", [
                                    _c(
                                      "h5",
                                      { staticClass: "font-weight-bold" },
                                      [_vm._v("Manual de uso")]
                                    ),
                                  ]),
                                ]),
                              ]),
                              _c("tbody", [
                                _c("tr", [
                                  _c("td"),
                                  _c(
                                    "td",
                                    { staticStyle: { color: "#000000DE" } },
                                    [
                                      item.manual
                                        ? _c("div", [
                                            _vm._v(_vm._s(item.manual) + " "),
                                          ])
                                        : _c("div", [
                                            _vm._v("(En construcción)"),
                                          ]),
                                      item.pdf
                                        ? _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: item.pdf,
                                                target: "_blank",
                                              },
                                            },
                                            [_vm._v("descargar aquí")]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]),
                              ]),
                            ]),
                          ]),
                        ],
                        1
                      )
                    }),
                  ],
                  2
                ),
              ],
              1
            ),
          ]
        : [
            _c(
              VTabs,
              {
                attrs: { vertical: "" },
                model: {
                  value: _vm.tab,
                  callback: function ($$v) {
                    _vm.tab = $$v
                  },
                  expression: "tab",
                },
              },
              [
                _c(
                  VTab,
                  {
                    on: {
                      click: function ($event) {
                        return _vm.sendtoGA(0)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("menu.data_platform")))]
                ),
                _c(
                  VTab,
                  {
                    on: {
                      click: function ($event) {
                        return _vm.sendtoGA(1)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("menu.audience")))]
                ),
                _c(
                  VTab,
                  {
                    on: {
                      click: function ($event) {
                        return _vm.sendtoGA(2)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("menu.attributes")) + " ")]
                ),
                _c(
                  VTab,
                  {
                    on: {
                      click: function ($event) {
                        return _vm.sendtoGA(3)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("menu.customer_insights")) + " ")]
                ),
                _vm._l(_vm.preguntas, function (item, a) {
                  return _c(
                    VTabItem,
                    [
                      _c(VContainer, { staticClass: "pb-0" }, [
                        _c("table", { attrs: { width: "100%" } }, [
                          _c("col", { staticStyle: { width: "1%" } }),
                          _c("col", { staticStyle: { width: "30%" } }),
                          _c("thead", [
                            _c("tr", [
                              _c(
                                "th",
                                [
                                  _c(
                                    VBtn,
                                    {
                                      staticStyle: {
                                        "background-color": "#0048CF",
                                      },
                                      attrs: { icon: "", color: "white" },
                                    },
                                    [_c(VIcon, [_vm._v("mdi-pencil")])],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("th", [
                                _c("h5", { staticClass: "font-weight-bold" }, [
                                  _vm._v("Descripción"),
                                ]),
                              ]),
                            ]),
                          ]),
                          _c("tbody", [
                            _c("tr", [
                              _c("td"),
                              _c(
                                "td",
                                { staticStyle: { color: "#000000DE" } },
                                [_vm._v(_vm._s(item.description))]
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                      _c(VContainer, { staticClass: "pb-0" }, [
                        _c("table", { attrs: { width: "100%" } }, [
                          _c("col", { staticStyle: { width: "1%" } }),
                          _c("col", { staticStyle: { width: "30%" } }),
                          _c("thead", [
                            _c("tr", [
                              _c(
                                "th",
                                [
                                  _c(
                                    VBtn,
                                    {
                                      staticStyle: {
                                        "background-color": "#0048CF",
                                      },
                                      attrs: { icon: "", color: "white" },
                                    },
                                    [_c(VIcon, [_vm._v("mdi-star")])],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("th", [
                                _c("h5", { staticClass: "font-weight-bold" }, [
                                  _vm._v("Funcionalidades principales"),
                                ]),
                              ]),
                            ]),
                          ]),
                          _c("tbody", [
                            _c("tr", [
                              _c("td"),
                              _c(
                                "td",
                                { staticStyle: { color: "#000000DE" } },
                                _vm._l(item.functionalities, function (func) {
                                  return _c("li", [_vm._v(_vm._s(func))])
                                }),
                                0
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                      _c(VContainer, { staticClass: "pb-0" }, [
                        _c("table", { attrs: { width: "100%" } }, [
                          _c("col", { staticStyle: { width: "1%" } }),
                          _c("col", { staticStyle: { width: "30%" } }),
                          _c("thead", [
                            _c("tr", [
                              _c(
                                "th",
                                [
                                  _c(
                                    VBtn,
                                    {
                                      staticStyle: {
                                        "background-color": "#0048CF",
                                      },
                                      attrs: { icon: "", color: "white" },
                                    },
                                    [_c(VIcon, [_vm._v("icon-search")])],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("th", [
                                _c("h5", { staticClass: "font-weight-bold" }, [
                                  _vm._v("Glosario de términos"),
                                ]),
                              ]),
                            ]),
                          ]),
                          _c("tbody", [
                            _c("tr", [
                              _c("td"),
                              _c(
                                "td",
                                { staticStyle: { color: "#000000DE" } },
                                [
                                  _vm.preguntas[a].gterms &&
                                  _vm.preguntas[a].gterms.length > 0
                                    ? _c(
                                        VCarousel,
                                        {
                                          staticClass: "myCarousel",
                                          staticStyle: { width: "97%" },
                                          attrs: {
                                            height: "auto",
                                            "hide-delimiters": "",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "prev",
                                                fn: function (ref) {
                                                  var on = ref.on
                                                  var attrs = ref.attrs
                                                  return [
                                                    _c(
                                                      VIcon,
                                                      _vm._g(
                                                        _vm._b(
                                                          {},
                                                          "v-icon",
                                                          attrs,
                                                          false
                                                        ),
                                                        on
                                                      ),
                                                      [
                                                        _vm._v(
                                                          "mdi-chevron-left"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                              {
                                                key: "next",
                                                fn: function (ref) {
                                                  var on = ref.on
                                                  var attrs = ref.attrs
                                                  return [
                                                    _c(
                                                      VIcon,
                                                      _vm._g(
                                                        _vm._b(
                                                          {},
                                                          "v-icon",
                                                          attrs,
                                                          false
                                                        ),
                                                        on
                                                      ),
                                                      [
                                                        _vm._v(
                                                          "mdi-chevron-right"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                          model: {
                                            value: _vm.model[a],
                                            callback: function ($$v) {
                                              _vm.$set(_vm.model, a, $$v)
                                            },
                                            expression: "model[a]",
                                          },
                                        },
                                        _vm._l(
                                          _vm.preguntas[a].gterms,
                                          function (term, i) {
                                            return _c(
                                              VCarouselItem,
                                              { key: i },
                                              [
                                                _c(
                                                  VCard,
                                                  {
                                                    staticClass: "mx-8",
                                                    attrs: { outlined: "" },
                                                  },
                                                  [
                                                    _c(VCardTitle, [
                                                      _vm._v(
                                                        _vm._s(term.title)
                                                      ),
                                                    ]),
                                                    _c(VCardText, [
                                                      _vm._v(
                                                        _vm._s(term.description)
                                                      ),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        1
                                      )
                                    : _c("div", [
                                        _vm._v(
                                          "Estamos trabajando en nuestro glosario de términos"
                                        ),
                                      ]),
                                ],
                                1
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                      _c(VContainer, { staticClass: "pb-0" }, [
                        _c("table", { attrs: { width: "100%" } }, [
                          _c("col", { staticStyle: { width: "1%" } }),
                          _c("col", { staticStyle: { width: "30%" } }),
                          _c("thead", [
                            _c("tr", [
                              _c(
                                "th",
                                [
                                  _c(
                                    VBtn,
                                    {
                                      staticStyle: {
                                        "background-color": "#0048CF",
                                      },
                                      attrs: { icon: "", color: "white" },
                                    },
                                    [
                                      _c(VIcon, [
                                        _vm._v("mdi-file-document-outline"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("th", [
                                _c("h5", { staticClass: "font-weight-bold" }, [
                                  _vm._v("Manual de uso"),
                                ]),
                              ]),
                            ]),
                          ]),
                          _c("tbody", [
                            _c("tr", [
                              _c("td"),
                              _c(
                                "td",
                                { staticStyle: { color: "#000000DE" } },
                                [
                                  item.manual
                                    ? _c("div", [
                                        _vm._v(_vm._s(item.manual) + " "),
                                      ])
                                    : _c("div", [_vm._v("(En construcción)")]),
                                  item.pdf
                                    ? _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: item.pdf,
                                            target: "_blank",
                                          },
                                        },
                                        [_vm._v("descargar aquí")]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  )
                }),
              ],
              2
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }